webpackJsonp([273476676058770],{

/***/ 1214:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0021_wrecking_ball.jpg","type":"Spell","subtype":null,"cost":0,"ATK":null,"HP":null,"rules_text_1":"Deal 2 damage to a building.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Wrecking Ball","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"Wrecked.","color":"Neutral","spec":"Bashing","bottom":"Magic","rulings":[],"keywords":[],"slug":"wrecking_ball"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"wrecking_ball","keywords":[],"imageRegex":"/wrecking_ball.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-wrecking-ball-4737fa620634c7c8d321.js